enum ECurrencyCode {
  Sterling = 'GBP',
  Euro = 'EUR',
  USDollar = 'USD',
  OZDollar = 'AUD'
}

export default ECurrencyCode;
